import { Button, Card, Group, Stack, Text } from "@mantine/core";
import { RETURN_LABEL } from "@pages/Credits/constants";
import type { RequestCreditsSectionProps } from "../types";

/**
 * Request Credits Section Component
 *
 * Allows team members to request additional credits from the business owner.
 * Only visible to non-owner team members.
 */
export const RequestCreditsSection = ({
  allocatedCredits,
  hasRequestedCredits,
  onRequestCredits,
  isRequesting,
}: RequestCreditsSectionProps) => {
  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder mt="lg">
      <Stack bg="#eef9ff" p="md">
        <Text c="dimmed" fw={600}>
          Request {RETURN_LABEL}s
        </Text>
        <Text c="dimmed" size="sm">
          As a team member, you can request more {RETURN_LABEL.toLowerCase()}s
          to be allocated to you.
        </Text>
        <Text c="dimmed" size="sm" fw={600}>
          Your allocated credits: {allocatedCredits ?? 0} {RETURN_LABEL}s
        </Text>
        <Group>
          <Button
            color="#0077CC"
            radius="md"
            onClick={onRequestCredits}
            loading={isRequesting}
            disabled={hasRequestedCredits}
          >
            {hasRequestedCredits ? "Pending Request" : "Request Credits"}
          </Button>
        </Group>
      </Stack>
    </Card>
  );
};
